export enum CustomEvents {
    resize = "resize",
    reportevent = "reportevent",
    submitevent = "submitevent",
    assignevent = "assignevent",
    qrcodeevent = "qrcodeevent",
    cancelevent = "cancelevent",
    eventdetails = "eventdetails",
    eventresult = "eventresult",
    eventmap = "eventmap",
    eventattachment = "eventattachment",
    eventlog = "eventlog",
    eventchat = "eventchat",
    eventrootcauseresolution = "eventrootcauseresolution",
    eventactionplan = "eventactionplan",
    eventresources = "eventresources",
    eventform = "eventform",
    eventdefault = "eventDefault",
    dashboardFilter = "dashboarFilter",
    dashboardDefault = "dashboardDefault",
    dashboardEventTime = "dashboardEventTime",
    dashboardEventUsers = "dashboardEventUsers",
    dashboardEventCompletedTime = "dashboardEventCompletedTime",
    dashboardEventProcessGroup = "dashboardEventProcessGroup",
    chatChanged = "chatChanged",
    fullScreenApp = "fullScreenApp",
    languageChange = "languageChange",
    resetFields = "resetFields",
    integrationValidation = "integrationValidation",
    dashBoardReport = "dashBoardReport",
    googleLabel = "googleLabel",
    readMessage = "readMessage",
    // Fired by WebSocketProvider when the SignalR hub reports a genuinely new
    // inbound Gmail message. An open inbox (EmailListBox) listens to refresh
    // itself in place when it's safe to do so (page 1 of INBOX, not searching).
    newEmailArrived = "newEmailArrived",
    newEmailMessage = "newEmailMessage",
    replyEmailMessage = "replyEmailMessage",
    replyAllEmailMessage ="replyAllEmailMessage",
    searchPeople = "searchPeople",
    peopleGroup = "peopleGroup",
    peopleExpandAll = "peopleExpandAll",
    dynamicFieldForm = "dynamicFieldForm",
    tabNavigation = "tabNavigation",
    peopleGroupSubmit = "peopleGroupSubmit",
    uploadAttachments = "uploadAttachments",
    emailMessage = "emailMessage",
    resetMessageEmail = "resetMessageEmail",
    expandedEvent = "expandedEvent",
    forwardEmailMessage = "forwardEmailMessage",
    processEntitySelection = "processEntitySelection",
    formLoader = "formLoader",
    formLoaderView = "formLoaderView",
    formDrawerClose = "formDrawerClose"
    ,
    navigatorPageChange = "navigatorPageChange",
    navigatorPageSizeChange = "navigatorPageSizeChange",
    navigatorSearch = "navigatorSearch",
    // Calendar RSVP — fired by the appointment tooltip so the parent
    // EventCalendar opens the meeting drawer in edit mode (used by the
    // "Propose new time" button).
    calendarOpenMeetingEdit = "calendarOpenMeetingEdit",
    // Holiday lifecycle — re-broadcast of the SignalR `holidayRequestCreated`
    // / `holidayRequestReviewed` payloads. Pages that show holiday data
    // (AttendancePage, HolidayOverviewPage) subscribe to refetch in-place.
    holidayRequestCreated = "holidayRequestCreated",
    holidayRequestReviewed = "holidayRequestReviewed",
    // Onboarding — the help chip lives in the top bar (SideMenu) while the
    // welcome dialog and the tour runner are mounted in AuthorizedLayout, so
    // they talk over the document event bus instead of threading props
    // through the whole layout tree.
    onboardingOpenWelcome = "onboardingOpenWelcome",
    onboardingStartTour = "onboardingStartTour",
    // Live data: the hub's "entitiesChanged" (detail = string[] of table
    // names changed by a save). Consume it with useLiveReload.
    entitiesChanged = "entitiesChanged",
    // Website lead chat: the hub's "leadChatChanged" (detail = conversation
    // id). Sent only to the platform's Sales users; no payload beyond the id.
    leadChatChanged = "leadChatChanged",
    // Support chat: the hub's "supportChatChanged" (detail = conversation id).
    // Sent to Fidava support agents, the requester and their tenant's admins.
    supportChatChanged = "supportChatChanged",
    // Social comment inbox: the hub's "socialCommentsChanged" (detail = how
    // many new comments). Sent to the tenant's Marketing / Sales users.
    socialCommentsChanged = "socialCommentsChanged",
    // Opens the support chat drawer (mounted in AuthorizedLayout) from any
    // entry point, e.g. the help menu. detail: { conversationId?: number }.
    supportChatOpen = "supportChatOpen",
    // The drawer's unread count, so the help button can badge it (detail = number).
    supportChatUnread = "supportChatUnread"
}

export enum CustomFormEvent {
    field = "field"
}

async function subscribe(eventName, listener) {
    await document.addEventListener(eventName, listener);
}

async function unsubscribe(eventName, listener?) {
    await document.removeEventListener(eventName, listener);
}

async function publish(eventName, data) {
    const event = new CustomEvent(eventName, { detail: data });
    await document.dispatchEvent(event);
}

export { publish, subscribe, unsubscribe };